import React, {Component} from 'react';
import axios from 'axios';
import {connect} from 'react-redux';
import {API_ROOT} from '../../utils';
import Button from '../button';
import Icon from '../icon';
import {findLabels} from '../../../actions/contactsGroupItemActions';
import {isSyncing, isSyncState} from '../../../actions/syncStatusActions';
import "./index.css";

class SyncStatus extends Component {

	constructor(props){
		super(props);

		this.syncHandler = this.syncHandler.bind(this);
	}

	syncInterval = null;

	componentDidMount(){

		this.props.callIsSyncState();

		this.syncInterval = setInterval(() => {
			this.props.callIsSyncState();
		}, 30000);

	}

	syncHandler(){
		this.props.setIsSyncing(true);

		this.props.callIsSyncState();

		axios.get(API_ROOT + '/api/labels/forceSync', {withCredentials: true}).then(() => {

			if(this.props.filteredStatus){
				if(this.props.enteredSearchValue !== ""){
					this.props.findLabelsByType(this.props.filteredStatus);
				} else {
					this.props.findLabelsByType(this.props.filteredStatus, this.props.labelsPageSize);
				}
			} else {
				if(this.props.enteredSearchValue !== ""){
					this.props.findLabels(false, true);
				} else {
					this.props.findLabels(this.props.labelsPageSize, true);
				}
			}

		});

		document.querySelector('.sync-status').classList.add("active");

		setTimeout(() => {
			document.querySelector('.sync-status').classList.remove("active");
		},5000);
	}

	render() {
		if(this.props.isSyncing){
			return (
				<Button
					className="btn-link btn-sm text-success sync-status text-decoration-none d-flex align-items-center loading"
				>
					<span className="sync-text pr-2">Syncing…</span>
					<div className="force-sync">
			            <span className="refresh-icon">
			                <svg version="1.1" baseProfile="tiny"
			                     xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 32 39.8"
			                     xmlSpace="preserve">
							<path fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="
								M1,19.9C1,15.7,2.7,12,5.4,9.3S11.9,4.9,16,4.9s7.9,1.7,10.6,4.4"/>
							<path fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="
								M31,19.9c0,4.1-1.7,7.9-4.4,10.6s-6.5,4.4-10.6,4.4s-7.9-1.7-10.6-4.4"/>
							<polyline fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" points="
								18.3,10.7 26.6,9.3 25.2,1 "/>
							<polyline fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" points="
								13.7,29.1 5.4,30.5 6.8,38.8 "/>
							</svg>
		                </span>
					</div>
				</Button>
			);
		} else {
			return (
				<Button
					disabled={!this.props.allLabelsFetched}
					onClick={this.syncHandler}
					className="btn-link btn-sm text-success sync-status text-decoration-none d-flex align-items-center"
				>
					<span className="sync-text pr-2">Sync</span>
					<div className="force-sync">
		                <span className="refresh-icon">
			                <svg version="1.1" baseProfile="tiny"
			                     xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 32 39.8"
			                     xmlSpace="preserve">
							<path fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="
								M1,19.9C1,15.7,2.7,12,5.4,9.3S11.9,4.9,16,4.9s7.9,1.7,10.6,4.4"/>
							<path fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="
								M31,19.9c0,4.1-1.7,7.9-4.4,10.6s-6.5,4.4-10.6,4.4s-7.9-1.7-10.6-4.4"/>
							<polyline fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" points="
								18.3,10.7 26.6,9.3 25.2,1 "/>
							<polyline fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" points="
								13.7,29.1 5.4,30.5 6.8,38.8 "/>
							</svg>
		                </span>
						<Icon name="check"/>
					</div>
				</Button>
			);
		}
	}
}

const mapStateToProps = (state) => {
	return {
		labelsPageSize : state.contactsGroupItemReducer.labelsPageSize,
		enteredSearchValue : state.contactsGroupItemReducer.getEnteredSearchValue,
		filteredStatus : state.contactsGroupItemReducer.getFilteredStatus,
		isSyncing : state.syncStatusReducer.isSyncing,
		isSyncState : state.syncStatusReducer.isSyncState,
		selectedContactsGroup : state.contactsGroupItemReducer.getSelectedContactsGroup,
		allLabelsFetched : state.contactsGroupItemReducer.allLabelsFetched
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		findLabels : (pageSize, directLaunch) => {
			dispatch(findLabels(pageSize, directLaunch))
		},
		setIsSyncing: (boolean) => {
			dispatch(isSyncing(boolean))
		},
		callIsSyncState: () => {
			dispatch(isSyncState())
		},
	}
};

export default connect(mapStateToProps, mapDispatchToProps)(SyncStatus);
